import { render, staticRenderFns } from "./SupplyPalletIndex.vue?vue&type=template&id=5ae9ae42"
import script from "./SupplyPalletIndex.vue?vue&type=script&lang=js"
export * from "./SupplyPalletIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports